"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewItemEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class ViewItemEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'view_item';
    }
    getData() {
        return {
            currency: this.config.currency,
            value: this.config.value,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.ViewItemEvent = ViewItemEvent;
//# sourceMappingURL=view-item.event.js.map